import { CreateCompanyPanelController } from '../controller/CreateCompanyPanelController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';

export class CreateCompanyPanelWebComponent extends BaseWebComponentElement {
  public controller!: CreateCompanyPanelController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: CreateCompanyPanelController,
    });
  }

  public get hasUnsavedChanges(): boolean {
    return this.controller.view.hasUnsavedChanges;
  }
}
